export const ROUTE_GROUP_EXPORT_ID = 'route-group';

export const ROUTE_GROUP_TITLE = 'Grupos de Rutas';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  company: 'Compañia',
  statusId: 'Estado',
};
